import { useDispatch } from 'react-redux';
import FJModal from '../../../FJModals/FJModal';
import FJUploadImageModal from '../view/FJUploadImageModal';
import { useSelector } from 'react-redux';
import FJActionModal from '../../../../redux/action/FJActionModal';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

/**
 * 文生图 上传图片作为提示词的弹窗
 */
const FJUploadImageModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const display = useSelector(state => state.modals.uploadImageAsPromptModalData.display);

    const hideUploadImageAsPromptModal = () => {
        dispatch(FJActionModal.hideUploadImageAsPromptModalAction());
    };

    const useImageAsPrompt = file => {
        dispatch(FJActionTextToImage.useImageAsPromptAction(file));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionModal.hideUploadImageAsPromptModalAction());
        dispatch(FJActionEditPage.openMediaLibraryAction({ isPrompt: true }));
    };

    return (
        <FJModal visible={display}>
            <FJUploadImageModal
                onClose={hideUploadImageAsPromptModal}
                uploadImage={useImageAsPrompt}
                openMediaLibrary={_openMediaLibrary}
            />
        </FJModal>
    );
};
export default FJUploadImageModalContainer;
